export const CLO_LIMIT_FEATURE = 'clo_portfolio_holdings_univers';
export const CLO_TRADE_LIMIT_FEATURE = 'clo_trade_data_universe';
export const BDC_DOWNLOAD_MONTHLY_FEATURE = 'bdc_portfolio_and_universe_download_monthly';
export const PREMIUM_MCP_LIMITS = 'premium_mcp_limits';
export const PUMA = 'puma_functionality';
export const PB_AI_LIMITS = 'PitchBook_AI_limits';
export const DATASET_ENTITLEMENTS = 'dataset_entitlements';

export const STATSIG_GATES = {
    ACCOUNT_PROVISIONING_HISTORY: 'Account_Provisioning_History',
    EMAIL_PRIMARY_MFA: 'email_primary_mfa',
    CLO_LIMIT_FEATURE,
    CLO_TRADE_LIMIT_FEATURE,
    BDC_DOWNLOAD_MONTHLY_FEATURE,
    PREMIUM_MCP_LIMITS,
    PUMA,
    DATASET_ENTITLEMENTS,
    PB_AI_LIMITS,
};
